module.exports = __webpack_public_path__ + "assets/img/0976e521b895a146f9277f95e31d0962.svg";